module.exports = __webpack_public_path__ + "static/media/blobLarge.cd973a1a.svg";